// LocationTracker.jsx
import { useState, useEffect, use, useRef } from "react";
import useGeolocation from "./useGeolocation";
import GoMap from "./GoMap";
import { useParams } from "react-router";
import ObserverAltura from "./ObserverAltura";
import AutoComplete from "./autocomplete";
import SolicitarJanela from "./solicitar_janela";
import Solicitando from "./solicitando";
import Solicitada from "./socilidata";
import DestinoOrganizado from "./destino_organizado";
import DestinosOrganizado from "./destinos_organizado";
import EscolherPagamento from "./escolher_pagamento";
import ClientPrompt from "./client_prompt";
import ErrorControl from "./error_control.js";
import Loader from "./loading";
import OtpPrompt from "./otp_promtp.js";
import { useNavigate } from "react-router";
import WS from "./webservice";
import SegmentedProgress from "./segmented";
import { Navigation, Car, ArrowLeft, User } from "lucide-react";
import StarPage from "./start";
import TopoMain from "./topo_main";

import * as S from "./styles";

function Main() {
  const navigate = useNavigate();
  const [timerOtp, setTimerOtp] = useState(0);
  const incrementer = useRef(null);
  const [stepAtual, setStepAtual] = useState(1);
  const [stepTotal, setStepTotal] = useState(5);
  const [showStart, setShowStart] = useState(true);
  const [showOtp, setShowOtp] = useState(false);
  const [randomCode, setRandomCode] = useState("");
  const [showMap, setShowMap] = useState(false);
  const [message, setMessage] = useState("");
  const [reverse, setReverse] = useState({});
  const [destino, setDestino] = useState({});
  const [valores, setValores] = useState({});
  const [position, setPosition] = useState({});
  const [uuid, setUuid] = useState("");
  const [ip, setIp] = useState("");
  const [cliente, setCliente] = useState({
    uuid: "",
    email: "",
    telefone: "",
    nome: "",
    dados: false,
    ok: false,
    otp: false,
    otpOk: false,
  });
  const [showSolicitar, setShowSolicitar] = useState(false);
  const [showSolicitando, setShowSolicitando] = useState(false);
  const [showSolicitada, setShowSolicitada] = useState(false);
  const [showCorridaCode, setShowCorridaCode] = useState("");
  const [msgErro, setMsgErro] = useState("");
  const [showLoader, setShowLoader] = useState(true);
  const [pagamentoEscolhido, setPagamentoEscolhido] = useState({});
  const [alturaFilho, setAlturaFilho] = useState(0);
  const [alturaFilhoTopo, setAlturaFilhoTopo] = useState(0);
  const [totem, setTotem] = useState({});
  const { id } = useParams();

  const reverseGeocode = async (coords) => {
    WS.gpsnovo(coords).then((data) => {
      setReverse(data);
    });
  };

  const delayDeactivateLoader = () => {
    setTimeout(() => setShowLoader(false), 2000);
  };

  const validaUsuario = async (cliente) => {
    setMsgErro("");
    setShowLoader(true);
    setStepAtual(2);
    let retorno = await WS.validaUsuario(totem.codigo, totem.nome, uuid, ip, cliente.email, cliente.nome, cliente.telefone);
    if (retorno.status) {
      delayDeactivateLoader();
      let novoCliente = { ...cliente, ok: true, otpOk: true, user: retorno.user, idremoto: retorno.id };
      setCliente(novoCliente);
    } else {
      delayDeactivateLoader();
      if (retorno.msgerro) {
        setMsgErro(retorno.msgerro);
      } else {
        setMsgErro("Erro ao solicitar código de segurança, verifique a conexão com a internet e tente novamente");
      }
    }
  };

  const startOtpTimer = async () => {
    await setTimerOtp(35);
    console.log("startOtpTimer", timerOtp);
    if (incrementer.current) clearInterval(incrementer.current);
    incrementer.current = setInterval(() => {
      setTimerOtp((tempoAtual) => {
        if (tempoAtual <= 1) {
          clearInterval(incrementer.current);
          return 0;
        }
        return tempoAtual - 1;
      });
    }, 1000);
  };

  const validadeCode = async (code) => {
    setMsgErro("");
    setStepAtual(3);
    setShowLoader(true);

    WS.validadeCore(cliente.idremoto, ip, cliente.email, cliente.nome, cliente.telefone, code, randomCode, cliente.idremoto).then((resposta) => {
      if (!!resposta.result) {
        if (!resposta.result.error) {
          setShowSolicitando(false);
          setShowCorridaCode(resposta.randomCode);
          setShowSolicitada(true);

          delayDeactivateLoader();
          setTimeout(() => track(resposta.randomCode), 3000);
        } else {
          delayDeactivateLoader();
          if (!!resposta.result.msgerro) {
            setMsgErro(resposta.result.msgerro);
          } else {
            setMsgErro("Erro ao solicitar a corrida, verifique a conexão com a internet e tente novamente");
          }
        }
      } else {
        delayDeactivateLoader();
        if (resposta.msgerro) {
          setMsgErro(resposta.msgerro);
        } else {
          setMsgErro("Erro ao solicitar a corrida, verifique a conexão com a internet e tente novamente");
        }
      }
    });
  };

  const handleRotaParaDestino = (destino) => {
    setDestino(destino);
    setStepAtual(4);
    WS.calcValor(position, [destino], totem).then((data) => {
      setValores(data);
      if (!!data && !!data.valores && data.valores.length > 0) {
        if (!!data.valores[0].pagamentos && !!data.valores[0].pagamentos.length > 0) {
          setPagamentoEscolhido(data.valores[0].pagamentos[0]);
        }
      }
    });
  };

  const handleSelectPagamento = (pagamento) => {
    setPagamentoEscolhido(pagamento.id);
    setStepAtual(5);
    setShowSolicitar(true);
  };

  const reset = () => {
    setReverse({});
    setDestino({});
    setValores({});
    setShowSolicitar(false);
    setShowSolicitando(false);
    setShowSolicitada(false);
    setShowLoader(true);
    setMsgErro("");
    setStepAtual(1);
    setShowCorridaCode("");
    setPagamentoEscolhido({});
    setCliente({});
    WS.getUserIp().then((data) => {
      setIp(data.ip);
    });
    WS.getDeviceId().then((data) => {
      setUuid(data);
    });
  };

  const handleAlturaMudou = (novaAltura) => {
    setAlturaFilho(novaAltura);
  };
  const handleAlturaMudouTopo = (novaAltura) => {
    setAlturaFilhoTopo(novaAltura);
  };
  var marcadores = [];

  if (!!position) {
    marcadores.push({ lat: position.latitude, lng: position.longitude, title: "Você está aqui" });
  }
  if (!!destino) {
    marcadores.push({ lat: destino.latitude, lng: destino.longitude, title: "Destino" });
  }
  useEffect(() => {
    WS.getUserIp().then((data) => {
      setIp(data.ip);
    });
    WS.getDeviceId().then((data) => {
      setUuid(data);
    });
    WS.totem(id).then((data) => {
      if (!data.error) {
        setTotem(data.dados);
        let reverseData = data.dados.autocomplete;
        if (!reverseData.linha) {
          reverseData.linha = reverseData.text;
        }
        setPosition({
          latitude: data.dados.latitude,
          longitude: data.dados.longitude,
        });
        setReverse(reverseData);
        delayDeactivateLoader();
      }
    });
  }, [id]);

  const resolicitar = () => {
    setShowSolicitar(false);
    setShowSolicitando(true);
    setShowLoader(true);
    WS.resolicitar(cliente.idremoto, ip, cliente.email, cliente.nome, cliente.telefone, randomCode, cliente.idremoto).then((resposta) => {
      if (!!resposta.result && !!resposta.result.status) {
        setMsgErro("");
        startOtpTimer();
        delayDeactivateLoader();
      } else {
        delayDeactivateLoader();
        if (!!resposta.result.msgerro) {
          setMsgErro(resposta.result.msgerro);
        } else {
          setMsgErro("Erro ao solicitar a corrida, verifique a conexão com a internet e tente novamente");
        }
      }
    });
  };

  const handleOnclicharSolicitar = () => {
    setShowSolicitar(false);
    setShowSolicitando(true);
    setShowLoader(true);
    WS.preSolicitar(reverse, [destino], pagamentoEscolhido, cliente, totem).then((resposta) => {
      delayDeactivateLoader();
      if (!!resposta.result) {
        startOtpTimer();
        setShowSolicitando(false);
        setShowOtp(true);
        setRandomCode(resposta.result.randomCode);
        //setShowSolicitada(true);
        //handleReload();
      } else {
        setShowSolicitando(false);
        setMsgErro("Erro ao solicitar a corrida, verifique a conexão com a internet e tente novamente");
      }
    });
  };
  const track = (corrida) => {
    navigate("/c/" + corrida);
  };
  const handleReload = () => {
    setTimeout(() => reset(), 5000);
  };
  let showBuscaEndereco = !!destino && !!destino.linha;
  let showClientPrompt = !cliente.dados;
  let allPromptsOK = cliente.ok;
  let showMsgErro = msgErro != "";

  return (
    <S.AppContainer>
      {showMap ?? (
        <S.MapBackground>
          {" "}
          <GoMap alturaOffSet={0} markO={marcadores} />
        </S.MapBackground>
      )}
      {!showStart && (
        <ObserverAltura top={true} onAlturaMudou={handleAlturaMudouTopo} style={{ pbackground: "#e0f7fa" }}>
          <TopoMain totalStep={stepTotal} atualStep={stepAtual} cliente={cliente} totem={totem} />
          <DestinosOrganizado origem={reverse} destinos={!!destino.linha ? [destino] : []} />

          {allPromptsOK && !showBuscaEndereco && (
            <AutoComplete alturaOffSet={alturaFilhoTopo + 20} coords={position} onSelect={handleRotaParaDestino} />
          )}
        </ObserverAltura>
      )}

      {!showStart && allPromptsOK && !!valores && !!valores.valores && !showSolicitar && !showSolicitando && !showSolicitada && !showOtp && (
        <ObserverAltura onAlturaMudou={handleAlturaMudou} style={{ pbackground: "#e0f7fa" }}>
          <EscolherPagamento valores={valores} onSelecionar={handleSelectPagamento} />{" "}
        </ObserverAltura>
      )}
      {!showStart && allPromptsOK && showSolicitar && (
        <SolicitarJanela
          coords={position}
          valores={valores}
          destino={destino}
          origem={reverse}
          pagamentoEscolhido={pagamentoEscolhido}
          cliente={cliente}
          onClick={handleOnclicharSolicitar}
        />
      )}
      {!showStart && showSolicitando && <Solicitando />}
      {!showStart && showSolicitada && <Solicitada corrida={showCorridaCode} track={track} />}
      {!showStart && showClientPrompt && (
        <ClientPrompt
          showMsgErro={showMsgErro}
          msgErro={msgErro}
          uuid={uuid}
          ip={ip}
          updateClient={(cliente) => {
            let novoCliente = { ...cliente, ok: true, otp: true, dados: true };
            validaUsuario(novoCliente);
          }}
        />
      )}
      {showOtp && (
        <OtpPrompt
          uuid={uuid}
          ip={ip}
          timerOtp={timerOtp}
          showMsgErro={showMsgErro}
          msgErro={msgErro}
          resent={resolicitar}
          updateOtp={(otp) => {
            validadeCode(otp);
          }}
          titulo={"O código de segurança foi enviado para seu telefone e email."}
        />
      )}

      {!!showStart && <StarPage onClick={() => setShowStart(false)} />}
      {showLoader && <Loader />}
    </S.AppContainer>
  );
}

export default Main;
